import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { compare } from '../utils/categories';
//
// Хук разбирает список категорий мероприятия на типы
//
const useCategories = ({ categories }) => {
	const { i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
    const [ addon, setAddon ] = useState([]);
    const [ admin, setAdmin ] = useState([]);
    const [ folders, setFolders ] = useState([]);
    const [ orphans, setOrphans ] = useState([]);

    useEffect(() => {
        if(!categories || !Array.isArray(categories)) {
            setAddon([]);
            setAdmin([]);
            setFolders([]);
            setOrphans([]);
            return;
        }

        const main  = [];
        const addon = [];
        const admin = [];

        categories.forEach(item => {
            switch(item.type) {
                case 'admin':
                    admin.push(item);
                    break;
                case 'addon':
                    addon.push(item);
                    break;
                default:
                    main.push(item);
                    break;
            }
        });

        setAddon(addon);
        setAdmin(admin);

        const folders = [];
        const orphans = [];

        main.forEach(cat => {
            if(cat.is_folder) folders.push({ ...cat, categories: [] });
            else if(!cat.folder) orphans.push(cat);
        });

        main.forEach(cat => {
            if(cat.is_folder || !cat.folder) return;
            const folder = folders.find(f => f._id === cat.folder);
            if(!folder) return;
            folder.categories.push(cat);
        });

        folders.sort((a, b) => compare(a, b, lang));
        orphans.sort((a, b) => compare(a, b, lang));
        setFolders(folders);
        setOrphans(orphans);

    }, [ categories, lang ]);

	return { addon, admin, folders, orphans };
};

export default useCategories;
